import type { IconButtonProps, IconProps } from '@chakra-ui/react';
import { IconButton } from '@chakra-ui/react';
import type { ComponentType } from 'react';

interface ButtonProps extends IconButtonProps {
  disabled?: boolean;
  iconComponent: ComponentType<IconProps>;
  onClick: () => void;
}

export function Button({
  iconComponent,
  disabled,
  onClick,
  ...rest
}: ButtonProps) {
  const Icon = iconComponent;
  return (
    <IconButton
      zIndex={2}
      icon={
        <Icon boxSize="xs" color={disabled ? 'blackAlpha.600' : undefined} />
      }
      pos="absolute"
      borderRadius={0}
      width="33.33%"
      height="100%"
      variant="unstyled"
      onClick={onClick}
      isDisabled={disabled}
      {...(!disabled ? { _hover: { bgColor: 'blackAlpha.50' } } : {})}
      {...rest}
    />
  );
}
